import { ClockIcon, CrossCircleIcon, SuccessIcon } from '@wonderschool/common-base-ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { KINDERSYSTEMS_REPORTS_STATUS } from '../../../reports/attendance/types';

interface KinderConnectAttendanceEventStatusProps {
  status?: KINDERSYSTEMS_REPORTS_STATUS;
  missingAutomatedCheckOutCorrection?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export const KinderConnectAttendanceEventStatus: React.FC<KinderConnectAttendanceEventStatusProps> = ({
  status,
  missingAutomatedCheckOutCorrection,
  onClick,
}) => {
  const { t } = useTranslation();

  if (missingAutomatedCheckOutCorrection) {
    return (
      <span className="flex w-32 flex-row rounded-full bg-red-200 px-2 py-2 text-sm" onClick={onClick}>
        <CrossCircleIcon className="mr-1 h-5 w-5 text-red-700" />
        {t('apps.kinderConnect.reportStatus.missingInfo')}
      </span>
    );
  }

  if (status === KINDERSYSTEMS_REPORTS_STATUS.TRANSFERRED) {
    return (
      <span className="flex w-32 flex-row rounded-full bg-green-200 px-2 py-2 text-sm" onClick={onClick}>
        <SuccessIcon className="mr-1 h-5 w-5 text-green-700" />
        {t('apps.kinderConnect.reportStatus.transferred')}
      </span>
    );
  }

  if (status === KINDERSYSTEMS_REPORTS_STATUS.ERROR) {
    return (
      <span className="flex w-32 flex-row rounded-full bg-red-200 px-2 py-2 text-sm" onClick={onClick}>
        <CrossCircleIcon className="mr-1 h-5 w-5 text-red-700" />
        {t('apps.kinderConnect.reportStatus.error')}
      </span>
    );
  }

  return (
    <span className="flex w-32 flex-row rounded-full bg-yellow-200 px-2 py-2 text-sm" onClick={onClick}>
      <ClockIcon className="mr-1 h-5 w-5 text-yellow-700" />
      {t('apps.kinderConnect.reportStatus.outOfSync')}
    </span>
  );
};
